module.exports = __webpack_public_path__ + "assets/img/ba72c3adce682711183e385fdb0e5c7c.svg";